import React from 'react';
import { FilterList } from '@mui/icons-material';
import { useSelector } from 'react-redux';

export default function FilterFAB({ onFilterClick, icon: Icon = FilterList }) {
  const { navBar } = useSelector((state) => state.systemBar);

  return (
    <button
      style={{
        position: 'fixed',
        bottom: `${navBar + 20}px`,
        right: '20px',
        width: 56,
        height: 56,
        borderRadius: '50%',
        backgroundColor: '#FFF',
        border: 'none',
        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
      }}
      onClick={onFilterClick}
    >
      <Icon style={{ width: 24, height: 24, color: '#333' }} />
    </button>
  );
}
